import { render, staticRenderFns } from "./xuekeyaoqiushezhi.vue?vue&type=template&id=776d025a&scoped=true"
import script from "./xuekeyaoqiushezhi.vue?vue&type=script&lang=js"
export * from "./xuekeyaoqiushezhi.vue?vue&type=script&lang=js"
import style0 from "./xuekeyaoqiushezhi.vue?vue&type=style&index=0&id=776d025a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776d025a",
  null
  
)

export default component.exports